export const groupBy = (items, prop) =>
    items.reduce((groups, item) => {
        const val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        return groups;
    }, {});

export function Deferred() {
    this.resolve = null;
    this.reject = null;
    this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
    });
    Object.freeze(this);
}

export function deferFactory(callback) {
    const defers = [];
    let loading = false;
    let loaded = false;
    let data = null;
    return (...args) => {
        if (loaded) {
            return data;
        }
        const defer = new Deferred();
        defers.push(defer);
        if (!loading) {
            loading = true;
            Promise.resolve(callback(...args))
                .then(response => {
                    data = response;
                    loading = false;
                    loaded = true;
                    defers.forEach(defer => defer.resolve(data));
                    defers.length = 0;
                })
                .catch(err => {
                    loading = false;
                    loaded = true;
                    defers.forEach(defer => defer.reject(err));
                    defers.length = 0;
                });
        }
        return defer.promise;
    };
}
